import { AxiosError } from 'axios';
import { create } from 'zustand';

import defaultCouponBanner from '~/assets/images/coupon-banner-default.png';
import { LOCATION_TYPE } from '~/constants/vCard';
import { LocationType } from '~/types/qrCode';

type Image = {
  imageId: string | null;
  scale: number;
  borderRadius: number;
  rotate: number;
  image: string | null;
  isImageIdSentToDB: boolean;
};

type CouponTemplateState = {
  locationType: LocationType;
  setLocationType: (newType: LocationType) => void;
  banner: Image;
  setBanner: (value: Partial<Image>) => void;
  barcode: Image;
  setBarcode: (value: Partial<Image>) => void;
  resetBanner: () => void;
  resetBarcode: () => void;
  showCompleteUrl: boolean;
  setShowCompleteUrl: (value: boolean) => void;
  createOrUpdateQRError: null | AxiosError;
  setCreateOrUpdateQrError: (error: null | AxiosError) => void;
  isManuallyLocationCompleteAddress: boolean;
  setIsManuallyLocationCompleteAddress: (value: boolean) => void;
  resetCouponTemplateState: () => void;
};

const imageDefault: Image = {
  imageId: null,
  scale: 100,
  borderRadius: 0,
  rotate: 0,
  image: null,
  isImageIdSentToDB: false,
};

const useCouponTemplateStore = create<CouponTemplateState>((set) => ({
  locationType: LOCATION_TYPE.FULL,
  setLocationType: (newType) => set({ locationType: newType }),
  banner: {
    ...imageDefault,
    image: defaultCouponBanner,
  },
  setBanner: (value) => set((state) => ({ banner: { ...state.banner, ...value } })),
  barcode: imageDefault,
  setBarcode: (value) => set((state) => ({ barcode: { ...state.barcode, ...value } })),
  resetBanner: () => set({ banner: imageDefault }),
  resetBarcode: () => set({ barcode: imageDefault }),
  showCompleteUrl: false,
  setShowCompleteUrl: (value) => set({ showCompleteUrl: value }),
  createOrUpdateQRError: null,
  setCreateOrUpdateQrError: (error) => set({ createOrUpdateQRError: error }),
  isManuallyLocationCompleteAddress: false,
  setIsManuallyLocationCompleteAddress: (value) => set({ isManuallyLocationCompleteAddress: value }),
  resetCouponTemplateState: () =>
    set({
      locationType: LOCATION_TYPE.FULL,
      banner: {
        ...imageDefault,
        image: defaultCouponBanner,
      },
      barcode: imageDefault,
      showCompleteUrl: false,
      createOrUpdateQRError: null,
      isManuallyLocationCompleteAddress: false,
    }),
}));

export default useCouponTemplateStore;
